'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _components = require('../../components');
var _constants = require('../../constants');
var _googleService = require('../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);

var _getLocalizedData2 = require('../../utils/getLocalizedData');var _getLocalizedData3 = _interopRequireDefault(_getLocalizedData2);
var _slugify = require('../../helpers/slugify');var _slugify2 = _interopRequireDefault(_slugify);
var _PublishPropertyForm = require('../../containers/PublishForm/PublishPropertyForm.scss');var _PublishPropertyForm2 = _interopRequireDefault(_PublishPropertyForm);
var _services = require('../../services');
var _MapboxService = require('../../services/MapboxService/MapboxService');var _MapboxService2 = _interopRequireDefault(_MapboxService);
var _helpers = require('../../services/MapboxService/helpers');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Helpers
var



PublishAddressBlock = function (_Component) {_inherits(PublishAddressBlock, _Component);function PublishAddressBlock() {var _temp, _this, _ret;_classCallCheck(this, PublishAddressBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showTooltip: false,
      manualAddress: false,
      showManualButton: false,
      showConfirmationButton: false,
      showPreloader: false,
      city: '',
      street: '',
      country: _this.props.isForeign ? '' : null }, _this.



























    onHideButton = function () {
      _this.setState({ showConfirmationButton: false });
      _this.isPinMoved = false;
      _this.props.scrollToAddress();
    }, _this.

    getComponentInstance = function (locationInputComponent) {
      _this.locationInputComponent = locationInputComponent;
    }, _this.

    getLocaleForGeocode = function () {return _this.props.locale === _constants.language.default ? _this.props.locale : _constants.language.fallback;}, _this.

    setHomeNumberManually = function (house_number) {
      _this.props.changeValue(_this.props.name, Object.assign({},
      _this.props.value, {
        en: Object.assign({},
        _this.props.value.en, {
          house_number: house_number }),

        he: Object.assign({},
        _this.props.value.he, {
          house_number: house_number }) }));


    }, _this.

    setPreloaderState = function (showPreloader) {return _this.setState({ showPreloader: showPreloader });}, _this.
    setManualButtonState = function (showManualButton) {return _this.setState({ showManualButton: showManualButton });}, _this.

    handleDragstart = function () {
      if (_this.props.isMobile) {
        _this._scrollPosition = window.pageYOffset;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + _this._scrollPosition + 'px';
      }
    }, _this.

    handleDragend = function () {
      if (_this.props.isMobile) {
        document.body.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, _this._scrollPosition);
      }var _this$draggablePin$ge =

      _this.draggablePin.getLngLat(),lat = _this$draggablePin$ge.lat,lng = _this$draggablePin$ge.lng;
      _this.geocodeLocation(lat, lng);
    }, _this.

    handleMapLoad = function () {
      _MapboxService2.default.changeMapLocale(_this.map, _this.props.locale);
    }, _this.

    initMap = function () {
      var loc = (0, _get2.default)(_this.props, 'value.location', false);
      var isFull = (0, _get2.default)(_this.props, 'value.isFull');
      var mapType = _this.props.isForeign ? 'foreignPublish' : 'publish';
      var mapOptions = Object.assign({},
      _MapboxService2.default.getMapOptions(mapType));


      if (loc && loc.lat) {
        mapOptions.center = {
          lat: loc.lat,
          lng: loc.lon };


        mapOptions.zoom = 17;
      }

      _this.map = _MapboxService2.default.createMapInstance(_this.mapWrapper, mapOptions, _this.props.locale);var _mapOptions$center =

      mapOptions.center,lat = _mapOptions$center.lat,lng = _mapOptions$center.lng;
      _this.draggablePin = _MapboxService2.default.createPin(lat, lng, {}, {
        draggable: true });


      _this.draggablePin.addTo(_this.map);

      _this.draggablePin.on('dragstart', _this.handleDragstart);
      _this.draggablePin.on('dragend', _this.handleDragend);

      if (_this.props.isMobile) {
        (0, _helpers.addMultitouchGestures)(_this.map);
      }
    }, _this.

    initialiseGoogleService = function (locale) {
      new _googleService2.default(locale, function (gs) {// eslint-disable-line no-new
        _this.googleService = gs;
      });
    }, _this.

    geocodeAddress = function (location) {
      var locale = _this.getLocaleForGeocode();
      var localizedAddress = location[locale] || {};

      var streetName = localizedAddress.street_name ? localizedAddress.street_name.replace(/ st.+$/gi, '') + ' ' : '';
      var houseNumber = localizedAddress.house_number ? localizedAddress.house_number + ', ' : '';
      var cityName = localizedAddress.city_name ? localizedAddress.city_name + ', ' : '';
      var countryName = localizedAddress.country_name ? localizedAddress.country_name : '';
      var neighborhoodName =
      localizedAddress.neighborhood &&
      localizedAddress.neighborhood !== localizedAddress.city_name ?
      localizedAddress.neighborhood : '';
      var address = '' + streetName + houseNumber + cityName + countryName + neighborhoodName;

      var fallbackTags = [];
      if (cityName) {
        fallbackTags.push(cityName);
        if (houseNumber) {
          fallbackTags.push(streetName);
          fallbackTags.push(houseNumber);
        } else if (streetName) {
          fallbackTags.push(streetName);
        } else if (neighborhoodName) {
          fallbackTags.push(neighborhoodName);
        }
      }

      var cleanedTags = fallbackTags.
      filter(function (part) {return !!part;}).
      map(function (keyPart) {return (0, _slugify2.default)(keyPart);});

      var tags = location.tags && location.tags.length ? location.tags : cleanedTags;

      var geocode = _this.googleService.geocodeLocusViaInternalBase(
      address, _this.props.isForeign ? null : tags, localizedAddress.city_name, localizedAddress.country_name);


      geocode.
      then(function (response) {
        _this.handleLocationInput(response);
        var hideHouseNumber = (0, _get2.default)(_this.props, 'value.hide_house_number');
        _this.props.changeValue(_this.props.name, Object.assign({}, response, { hide_house_number: hideHouseNumber }));
        _this.setState({ showPreloader: false });
      });
    }, _this.

    isIncludeUnnamed = function (str) {return str.toLocaleLowerCase().includes('unnamed');}, _this.

    checkIsUnnamedRoad = function (resp) {
      var heStreet = (0, _get2.default)(resp, 'he.street_name', '') || '';
      var enStreet = (0, _get2.default)(resp, 'en.street_name', '') || '';
      var heFormatted = (0, _get2.default)(resp, 'he.formatted', '') || '';
      var enFormatted = (0, _get2.default)(resp, 'en.formatted', '') || '';

      return [heStreet, enStreet, heFormatted, enFormatted].some(_this.isIncludeUnnamed);
    }, _this.

    geocodeLocation = function (lat, lng) {
      if (!_this.state.manualAddress) {
        _this.isPinMoved = true;
        _this.googleService.geocodeByCoordinate({ lat: lat, lng: lng }, _this.props.isForeign).
        then(function (response) {
          if (response && (0, _get2.default)(response, 'en.city_name') && !_this.checkIsUnnamedRoad(response)) {
            response.location = { lat: lat, lon: lng };
            _this.handleLocationInput(response);
            var hideHouseNumber = (0, _get2.default)(_this.props, 'value.hide_house_number');
            _this.props.changeValue(_this.props.name, Object.assign({}, response, { hide_house_number: hideHouseNumber }));

            _this.setState({ showConfirmationButton: true });
          } else {
            _this.setState({ showConfirmationButton: false });
            _this.props.changeValue(_this.props.name, null);
          }

          _this.setState({ showPreloader: false });
        });
      } else {
        _this.props.changeValue(_this.props.name, Object.assign({},
        _this.props.value, {
          location: { lat: lat, lon: lng } }));

      }
    }, _this.

    geocodeMyLocation = function (_ref) {var lat = _ref.lat,lng = _ref.lng;return _this.geocodeLocation(lat, lng);}, _this.

    clearAddressPart = function (targetPart, query, clearHouse) {var _location;
      var locale = _this.getLocaleForGeocode();
      var location = (_location = {}, _location[
      locale] = Object.assign({},
      (0, _get2.default)(_this.props, 'value.' + locale), {
        house_number: '' }), _location.

      tags = (0, _get2.default)(_this.props, 'value.tags'), _location);


      if (targetPart === 'country_name') {
        _this.setState({ country: query, city: '', street: '' });
        return _this.handleLocationInput(null);
      }

      if (targetPart === 'city_name') {
        location[locale].street_name = '';
        location[locale].city_name = '';
        location[locale].neighborhood = '';
        _this.setState({ city: query, street: '' });
        if (!_this.props.isForeign) {
          return _this.handleLocationInput(null);
        }
      }

      if (targetPart === 'street_name') {
        location[locale].street_name = '';
        _this.setState({ street: query, city: '' });
        return _this.googleService.autocompleteLocus(location[locale].city_name, null, 'city');
      }

      if (targetPart === 'house_number' && !clearHouse) {
        var data = Object.assign({}, location, { isFull: false });
        var updatedData = _this.props.value ? Object.assign({}, _this.props.value, data) : data;

        return _this.props.changeValue(_this.props.name, updatedData);
      }

      return _this.geocodeAddress(location);
    }, _this.

    clearMap = function () {var _ref2 =
      _this.props.isForeign ?
      _MapboxService2.default.getMapOptions('foreignPublish').center : _constants.mapDefaultOptions.center,lat = _ref2.lat,lon = _ref2.lng;
      _MapboxService2.default.changeMapZoom(_this.map, { lat: lat, lon: lon });
    }, _this.

    saveAddressValue = function (evt) {
      evt.preventDefault();

      if ((0, _get2.default)(_this.props, 'value.en.house_number')) {
        _this.setState({
          manualAddress: false,
          showManualButton: false });

      }
      _this.handleSelectLocation(Object.assign({},
      _this.props.value, {
        isFull: true }));

    }, _this.

    createAddress = function (evt) {
      evt.preventDefault();

      if ((0, _get2.default)(_this.props, 'value.en.house_number')) {
        _this.setState({
          manualAddress: false,
          showManualButton: false,
          showPreloader: true });var _this$props =


        _this.props,value = _this$props.value,token = _this$props.token;
        _this.googleService.createAddressInLocus(value, token).
        then(_this.geocodeAddress).
        catch(function (err) {
          _this.googleService.handleError(err);
          _this.setState({ showPreloader: false });
          _this.locationInputComponent.setError(_constants.publishFormErrorNames.addressWasNotCreated);
        });
      }
    }, _this.

    handleCancelManual = function (evt) {
      evt.preventDefault();
      _this.setHomeNumberManually(null);
      _this.setState({ manualAddress: false });
    }, _this.

    enableManualMode = function (evt) {
      evt.preventDefault();
      _this.locationInputComponent.clearErrors(function (error) {return !error.startsWith('HOUSE') && !error.startsWith('ADDRESS');});
      _this.setState({ manualAddress: true, showConfirmationButton: false });
      _this.isPinMoved = false;
    }, _this.

    handleSelectLocation = function (_ref3) {var bounds = _ref3.map,location = _ref3.location,data = _objectWithoutProperties(_ref3, ['map', 'location']);
      _this.props.changeValue(_this.props.name, Object.assign({ location: location }, data));

      if (!data.isFull && bounds && bounds.topright) {
        _MapboxService2.default.changeMapBoundsByViewport(_this.map, bounds);
      }

      if (!data.isFull && bounds && bounds.west) {
        var boundsMap = [bounds.west, bounds.south, bounds.east, bounds.north];
        _MapboxService2.default.changeMapBounds(_this.map, boundsMap);
      }

      if (data.isFull) {
        _MapboxService2.default.changeMapZoom(_this.map, location, 17);
      }

      if (data.zoom) {
        var zoom = data.tags && data.tags.length === 3 ? 17 : data.zoom;
        _MapboxService2.default.changeMapZoom(_this.map, location, zoom);
      }

      if ((0, _get2.default)(data, 'en.country_name')) {
        _this.draggablePin.setLngLat({ lat: location.lat, lng: location.lon });
      }

      if ((0, _get2.default)(data, 'en.city_name') && !_this.checkIsUnnamedRoad(data)) {
        _this.draggablePin.setLngLat({ lat: location.lat, lng: location.lon });
      }
      _this.setState({ showConfirmationButton: data.isFull });
    }, _this.

    handleLocationInput = function (data) {
      if (!data) {
        _this.props.changeValue(_this.props.name, data);
        _this.clearMap();
      } else {
        var updatedData = _this.props.value ? Object.assign({},
        _this.props.value, data, { tags: data.tags, place_id: data.place_id }) :
        data;
        _this.handleSelectLocation(updatedData);
        if (updatedData.isFull) {
          // !this.isPinMoved && this.props.scrollToAddress();
          _this.props.changeValue(_this.props.name, updatedData);
        }
      }
    }, _this.

    handleClickMyLocation = function (evt) {
      evt.preventDefault();
      _this.setState({ showPreloader: true });
      _services.GeolocationService.geolocate({ enableHighAccuracy: true }).
      then(_this.geocodeMyLocation).
      catch(function (error) {return console.error(error);});
    }, _this.

    constructAddress = function (addressData, locale) {
      var lang = addressData[locale] ? locale : _constants.language.fallback;
      var address = addressData[lang].street_name + ' ' + addressData[lang].house_number + ',\n      ' +
      addressData[lang].city_name;
      var addressString = _this.props.isForeign ? address + ', ' + addressData[lang].country_name : address;
      return addressData[lang].formatted ?
      addressData[lang].formatted :
      addressString;
    }, _this.

    renderHideNumber = function (_ref4) {var input = _ref4.input;
      var inputLabel = input.value ?
      _this.props.translate('showHouseNumber') :
      _this.props.translate('hideHouseNumber');

      return _react2.default.createElement('div', { className: _PublishPropertyForm2.default.hideHouseNumber },
        _react2.default.createElement(_components.OMCheckbox, {
          id: 'hideHouseNumber',
          label: inputLabel,
          field: Object.assign({}, input, { checked: input.value }) }));


    }, _this.

    renderManualButtons = function () {return _this.state.manualAddress &&
      _react2.default.createElement('div', { className: _PublishPropertyForm2.default.mapButtons },
        _react2.default.createElement('button', { onClick: _this.props.isForeign ? _this.saveAddressValue : _this.createAddress },
          _this.props.translate('save')),

        _react2.default.createElement('button', { onClick: _this.handleCancelManual },
          _this.props.translate('cancel')));}, _this.




    renderMyLocationButton = function () {return (
        _react2.default.createElement('button', {
            className: _PublishPropertyForm2.default.locationButton,
            onClick: _this.handleClickMyLocation },

          _react2.default.createElement('i', { className: 'icon icon-location' })));}, _temp), _possibleConstructorReturn(_this, _ret);}PublishAddressBlock.prototype.componentDidMount = function componentDidMount() {var _this2 = this;this.initialiseGoogleService(this.props.locale);setTimeout(function () {_this2.initMap();});};PublishAddressBlock.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var localeChanged = newProps.locale && newProps.locale !== this.props.locale;if (localeChanged) {_MapboxService2.default.changeMapLocale(this.map, newProps.locale);delete global.google;this.initialiseGoogleService(newProps.locale);}};PublishAddressBlock.prototype.componentWillUnmount = function componentWillUnmount() {_MapboxService2.default.cleanup();this.draggablePin && this.draggablePin.remove();this.map && this.map.remove();if (this.props.isMobile) {(0, _helpers.removeMultitouchGestures)(this.map);}};PublishAddressBlock.prototype.



  render = function render() {var _cx,_this3 = this;var _props =
    this.props,error = _props.error,anyTouched = _props.anyTouched,reportIssue = _props.reportIssue,value = _props.value,locale = _props.locale,token = _props.token,isPublishFrom = _props.isPublishFrom;var _getLocalizedData =
    (0, _getLocalizedData3.default)(value || {}, locale, _constants.language.fallback),address = _getLocalizedData.result,isDefaultLanguage = _getLocalizedData.isDefaultLanguage,name = _getLocalizedData.name;
    // const withContinueButton = get(address, 'house_number') && !get(value, 'isFull') && !this.state.manualAddress;
    var isShouldBeShow = this.state.showConfirmationButton && (0, _get2.default)(value, 'isFull') && !this.props.isForeign;
    return (
      _react2.default.createElement(_reactScroll.Element, {
          name: name,
          className: (0, _classnames2.default)(
          _PublishPropertyForm2.default.sectionBlock,
          _PublishPropertyForm2.default.addressBlock,
          this.props.className, (_cx = {}, _cx[
          _PublishPropertyForm2.default.withContinueButton] = isShouldBeShow, _cx)) },


        isPublishFrom && _react2.default.createElement('div', { className: _PublishPropertyForm2.default.title }, this.props.translate('sections', 'address')),
        isPublishFrom && _react2.default.createElement('div', {
            className: _PublishPropertyForm2.default.reportAddressIssue,
            onClick: function onClick() {return reportIssue({ issueType: _constants.issueTypes.ADDRESS, reportType: _constants.reportTypes.PUBLISH });} },

          this.props.translate('reportAddressIssue')),

        _react2.default.createElement('div', { className: _PublishPropertyForm2.default.locationInputWrapper },
          _react2.default.createElement('div', null,
            _react2.default.createElement(_components.PublishFormLocationInput, {
              locale: this.props.locale,
              placeholder: '' + this.props.translate('addressInputPlaceHolder'),
              getInputData: this.handleLocationInput,
              changeValue: this.props.changeValue,
              googleService: this.googleService,
              initialValue: this.props.initialValue,
              translateTooltip: this.props.translate('enterFullAddress'),
              isInvalid: !!error && anyTouched,
              isMobile: this.props.isMobile,
              translate: this.props.translate,
              isRtl: this.props.isRtl,
              address: address || {},
              fullAddressModel: this.props.value,
              isFullAddress: (0, _get2.default)(value, 'isFull'),
              clearAddressPart: this.clearAddressPart,
              isDefaultLanguage: isDefaultLanguage,
              withTooltipImage: (0, _get2.default)(this.props, 'value.hide_house_number'),
              isRealtor: this.props.isRealtor,
              city_name: this.state.city,
              street_name: this.state.street,
              country_name: this.state.country,
              token: token,
              manualAddress: this.state.manualAddress,
              setHomeNumberManually: this.setHomeNumberManually,
              setPreloaderState: this.setPreloaderState,
              setManualButtonState: this.setManualButtonState,
              getComponentInstance: this.getComponentInstance,
              isForeign: this.props.isForeign,
              name: this.props.name,
              rootTranslate: this.props.rootTranslate }))),



        this.props.isRealtor && isPublishFrom &&
        _react2.default.createElement(_reduxForm.Field, {
          normalize: function normalize(currentValue) {return !!currentValue;},
          name: 'address.hide_house_number',
          props: { locale: this.props.locale },
          component: this.renderHideNumber }),


        _react2.default.createElement('div', { className: _PublishPropertyForm2.default.map },
          _react2.default.createElement('div', { style: { width: '100%', height: '100%' }, ref: function ref(map) {_this3.mapWrapper = map;} }),
          this.state.showPreloader && _react2.default.createElement('div', { className: _PublishPropertyForm2.default.preloader }, _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })),
          this.renderMyLocationButton()),

        this.state.showManualButton && !this.state.manualAddress && _react2.default.createElement('div', {
            className: _PublishPropertyForm2.default.mapPopup },

          _react2.default.createElement('div', { className: _PublishPropertyForm2.default.locateManually }, this.props.translate('locateManually')),
          _react2.default.createElement('button', { onClick: this.enableManualMode },
            this.props.translate('locateManuallyButton'))),


        this.renderManualButtons(),
        isShouldBeShow && isPublishFrom && _react2.default.createElement('div', { onClick: this.onHideButton, className: _PublishPropertyForm2.default.continueButton }, this.props.translate('continueButton'))));


  };return PublishAddressBlock;}(_react.Component);exports.default = PublishAddressBlock;


PublishAddressBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  changeValue: _propTypes2.default.func.isRequired,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  token: _propTypes2.default.string,
  error: _propTypes2.default.any,
  anyTouched: _propTypes2.default.bool,
  initialValue: _propTypes2.default.any,
  value: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  reportIssue: _propTypes2.default.func,
  scrollToAddress: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  isRealtor: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool,
  isPublishFrom: _propTypes2.default.bool,
  className: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishAddressBlock/PublishAddressBlock.js
// module id = 2841
// module chunks = 0